import React from 'react';
import { Button, ButtonGroup, IconButton } from '@chakra-ui/react';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from "react-i18next";

interface ScoreDetailActionButtonProps {
  onOpen: () => void;
  onClose: () => void;
  onSave: () => void;
  isOpen: boolean;
  buttonDisclosureProps: React.HTMLAttributes<HTMLElement>;
}

export function ScoreDetailsActionButtons(props: ScoreDetailActionButtonProps): React.ReactElement {
    const { t } = useTranslation('common');
  const { onOpen, onClose, onSave, isOpen, buttonDisclosureProps } = props;

  if (isOpen) {
    return (
      <ButtonGroup>
        <Button {...buttonDisclosureProps} size="sm" onClick={onClose}>
          {t('common:cancel')}
                        </Button>
        <Button {...buttonDisclosureProps} size="sm" variant="solid" onClick={onSave}>
          {t('common:save')}
                        </Button>
      </ButtonGroup>
    );
  }
  return (
    <IconButton
      {...buttonDisclosureProps}
      aria-label={t('common:edit')}
      variant="ghost"
      size="sm"
      onClick={onOpen}
      icon={<FontAwesomeIcon icon={regular('edit')} />}
    />
  );
}
